var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "720", title: "选择艺术家" },
          on: { "on-ok": _vm.cursorSelect },
          model: {
            value: _vm.showSelectAuction,
            callback: function ($$v) {
              _vm.showSelectAuction = $$v
            },
            expression: "showSelectAuction",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("Input", {
                staticClass: "w200",
                attrs: { placeholder: "名称搜索" },
                on: { "on-enter": _vm.searchCAction },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _vm._v(" "),
              _c(
                "Button",
                {
                  staticClass: "ml20",
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.searchCAction($event)
                    },
                  },
                },
                [_vm._v("筛选")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "h400 mt20",
              staticStyle: { "border-top": "1px solid #eee" },
            },
            [
              _c(
                "table",
                { staticClass: "spec-table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", { attrs: { width: "55%", align: "center" } }, [
                        _vm._v("用户信息"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "30%", align: "center" } }, [
                        _vm._v("合作者身份"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("操作"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resultData, function (m, i) {
                    return _c("tbody", { key: i }, [
                      _c("tr", { staticClass: "border-t" }, [
                        _c("td", { staticClass: "bgWhite" }, [
                          _c(
                            "div",
                            { staticClass: "display-flex item-align-center" },
                            [
                              m.avatar
                                ? _c("img", {
                                    staticStyle: {
                                      width: "90px",
                                      height: "90px",
                                      display: "block",
                                      "flex-shrink": "0",
                                    },
                                    attrs: { src: m.avatar },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml10" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(m.uid) + " | " + _vm._s(m.uname)
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [_c("p", [_vm._v(_vm._s(m.identity_name))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _vm.selectedAuctionIdList.indexOf(m.uid) == -1
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.auctionSelectedAction(
                                            $event,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          _vm.auctionCancelAction(
                                            $event,
                                            _vm.selectedAuctionIdList.indexOf(
                                              m.uid
                                            )
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消选择")]
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c("Page", {
                staticStyle: { "text-align": "right" },
                attrs: {
                  total: _vm.total,
                  "page-size": _vm.queryParams.size,
                  "show-sizer": "",
                  "show-total": "",
                  "show-elevator": "",
                  current: _vm.queryParams.page,
                },
                on: {
                  "on-page-size-change": _vm.changePageSize,
                  "on-change": _vm.changePage,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }